import React, { useState, useEffect } from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import useSWR from 'swr'
import { getData } from '../components/sfc/component-helpers/requesthelpers'
import Layout from '../components/layout'
import Topper from '../components/sfc/topper'
import SummaryNumbers from '../components/vaccine/summaryNumbers'
import CreditsSection from '../components/sfc/creditssection'
import LatestFeed from '../components/sfc/latestfeed'
import Newsletter from '../components/sfc/newsletter'
import Info from '../components/vaccine/info'
import ClosestVaccines from '../components/vaccine/closest'
import MapboxCA from '../components/vaccine/mapbox/mapboxca'
import MapboxTX from '../components/vaccine/mapbox/mapboxtx'
import Sponsor from '../components/vaccine/sponsor'
import SecondarySponsor from '../components/vaccine/secondarysponsor'
import { appCheck } from 'sfc-utils'
//import RatesSection from '../components/vaccine/ratesSection'
import RatesSection from '../components/vaccine/ratesSection'
import LazyLoad from 'react-lazyload'
import AllUSSection from '../components/vaccine/allUSSection'
import AssignmentEditor from '../components/vaccine/assignmentEditor'

const IndexPage = ({ data }) => {
  // get vaccine phase tracker data
  const { data: vaccineData, vaccineError } = useSWR(
    'https://files.sfchronicle.com/project-feeds/covid-vaccine-data-current_vaccines.json',
    getData,
    {
      // onSuccess: (data) => console.log(data),
      // onError: (err) => console.log(err),
    }
  )

  let {
    site: { siteMetadata },
    allRelatedLinksSheetJson: { nodes: relatedLinks },
    allStorySettingsSheetJson: { nodes: storySettings },
    allDataJson: { nodes: topperText },
    allCreditsSheetJson: { nodes: credits },
    allVaccineData: { nodes: vaccineLocData },
  } = data

  let vaccineLocations = vaccineLocData
    ? vaccineLocData[0].finalJSON.features
    : null

  // get copy
  const useLinks = relatedLinks.slice(0, -1)
  const newstorySettings = storySettings[0]
  const useTopperText = topperText.slice(-1)[0].trackerText[0]
  const aboutData = useTopperText.aboutData
  const phaseBase = require('../data/timeline_phases.sheet.json')
  const phaseDetails = require('../data/timeline_details.sheet.json')
  const phaseSource = newstorySettings.Phase_Source
  const phaseDek = newstorySettings.Phase_Dek
  siteMetadata.PROJECT.DISPLAY_TITLE = newstorySettings.Display_Title

  // console.log("we are in", siteMetadata.PROJECT.MARKET_STATE )

  if (newstorySettings.Byline.length) {
    siteMetadata.PROJECT.AUTHORS = newstorySettings.Byline.split(',')
  }

  // Get closest vaccines for the closest vaccines section
  let closest = []
  let descriptionRow

  //Set moddate

  if (vaccineData) {
    // if mod date of one the national vaccine feed is later than c2p mod date, use national feed mod date
    let natDate = vaccineData[0].c2p_pubdate
    siteMetadata.PROJECT.modDateString = newstorySettings.Mod_Date

    if (Date.parse(natDate) > Date.parse(newstorySettings.Mod_Date)) {
      siteMetadata.PROJECT.ISO_MODDATE = Date.parse(natDate)
      siteMetadata.PROJECT.modDateString = natDate
    }
    // no mod date on the c2p but is mod date in the feed

    if (!newstorySettings.Mod_Date && natDate) {
      siteMetadata.PROJECT.ISO_MODDATE = Date.parse(natDate)
      siteMetadata.PROJECT.modDateString = natDate
    }

    // approved = vaccineData.filter((item) => item.stage === 'Approved')
    closest = vaccineData.filter((item) => item.closest === 'yes')
    descriptionRow = vaccineData.find((item) => item.Company === 'explanation')

    // make pieces for head
    siteMetadata.topperText = useTopperText
  }

  // add link to explainer deck if it exists
  let [richie, setRichie] = useState([])

  useEffect(() => {
    let myRichie = appCheck() ? '?fromRichie=1' : '?'
    setRichie(myRichie)
  }, [])
  // let richie = appCheck() ? "?fromRichie=1" : ''

  // get big number data
  // this must come after initializing the newstorySettings var
  const { data: numberBreakdownData, numberBreakdownDataError } = useSWR(
    newstorySettings.Big_Number_Data,
    getData,
    {
      // onSuccess: (data) => console.log(data),
      // onError: (err) => console.log(err),
    }
  )

  return (
    <Layout meta={siteMetadata}>
      <Topper
        updateLine={newstorySettings.Update_Line || null}
        meta={siteMetadata}
        MARKET_STATE={siteMetadata.PROJECT.MARKET_STATE}
      />
      <main>
        <article className="has-padding">
          <div className="container quick-flex column-tablet">
            {newstorySettings.sponsor_url && newstorySettings.sponsor_img && (
              <div className="sponsor-container">
                <Sponsor
                  img={newstorySettings.sponsor_img}
                  link={newstorySettings.sponsor_url}
                  kicker={newstorySettings.sponsor_text_kicker}
                  text={newstorySettings.sponsor_text}
                  textUrl={newstorySettings.sponsor_text_url}
                />
              </div>
            )}
            {newstorySettings.Page_Dek === '' ? (
              <p className="container dek">
                Use this tracker to follow COVID-19 vaccine distribution
                progress in {siteMetadata.PROJECT.MARKET_STATE} and nationwide.
              </p>
            ) : (
              <p
                className="container dek"
                dangerouslySetInnerHTML={{
                  __html: newstorySettings.Page_Dek,
                }}
              ></p>
            )}
          </div>

          {newstorySettings.Vaccine_Feed && (
            <LatestFeed feed={newstorySettings.Vaccine_Feed} />
          )}

          {numberBreakdownData && (
            <SummaryNumbers
              MARKET_STATE={siteMetadata.PROJECT.MARKET_STATE}
              bigNumbers={numberBreakdownData}
            />
          )}

          <div className="container-l">
            <AllUSSection
              MARKET_STATE={siteMetadata.PROJECT.MARKET_STATE}
              numberBreakdownData={numberBreakdownData}
              marketKey={newstorySettings.Market_Key}
            />
          </div>

          <div id="ad">
            <p id="adhed">Advertisement</p>
            <div id="APflex">
              <script
                type="text/javascript"
                dangerouslySetInnerHTML={{
                  __html: '/*<![CDATA[*/hearstPlaceAd("APflex");/*]]>*/',
                }}
              ></script>
            </div>
          </div>

          {newstorySettings.Vaccinations_Data_Dek &&
            newstorySettings.Vaccinations_Data_Hed && (
              <section>
                <div className="container">
                  <h3 className="subhed">
                    {newstorySettings.Vaccinations_Data_Hed}
                  </h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: newstorySettings.Vaccinations_Data_Dek,
                    }}
                  ></p>
                </div>

                {newstorySettings.Vaccinations_Data_Source &&
                  newstorySettings.Vaccinations_Data && (
                    <LazyLoad once offset={200}>
                      <div className="container-l">
                        <RatesSection
                          mapURL={newstorySettings.Vaccinations_Data}
                          mapGeography={siteMetadata.PROJECT.MAP_GEOGRAPHY}
                          mapState={siteMetadata.PROJECT.MARKET_STATE}
                          source={newstorySettings.Vaccinations_Data_Source}
                          marketKey={newstorySettings.Market_Key}
                        />
                      </div>
                    </LazyLoad>
                  )}
              </section>
            )}

          <div id="ad">
            <p id="adhed">Advertisement</p>
            <div id="APflex">
              <script
                type="text/javascript"
                dangerouslySetInnerHTML={{
                  __html: '/*<![CDATA[*/hearstPlaceAd("APflex");/*]]>*/',
                }}
              ></script>
            </div>
          </div>

          {/* show closest */}
          {closest.length > 0 && (
            <div className="container-l">
              <ClosestVaccines
                lastUpdated={vaccineData[0].c2p_pubdate}
                data={closest}
                header={useTopperText.progressSwitcheroo.approvedVaccines}
                dek={useTopperText.detailDek}
                descriptionRow={descriptionRow}
              />
            </div>
          )}

          <div id="ad">
            <p id="adhed">Advertisement</p>
            <div id="BPflex">
              <script
                type="text/javascript"
                dangerouslySetInnerHTML={{
                  __html: '/*<![CDATA[*/hearstPlaceAd("APflex");/*]]>*/',
                }}
              ></script>
            </div>
          </div>

          {(siteMetadata.PROJECT.MARKET_STATE === 'California' ||
            siteMetadata.PROJECT.MARKET_STATE === 'Texas') &&
            newstorySettings.Vaccinations_Sites_Dek &&
            newstorySettings.Vaccinations_Sites_Hed && (
              <section>
                <div className="container">
                  <h3 className="subhed">
                    {newstorySettings.Vaccinations_Sites_Hed}
                  </h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: newstorySettings.Vaccinations_Sites_Dek,
                    }}
                  ></p>
                </div>

                {/*Mapbox zoomed into Bay Area for SFC */}

                {newstorySettings.Vaccinations_Sites_Source &&
                  newstorySettings.Market_Key === 'SFC' && (
                    <LazyLoad once offset={200}>
                      <div className="container-l">
                        <MapboxCA
                          mapData={vaccineLocations}
                          center={[-122.447303, 37.753574]}
                          zoom={9}
                          mapStyle="mapbox://styles/devhub/ckcnowjqe19tx1ilpldbyd6zo"
                        />
                        <p className="footnote">
                          {newstorySettings.Vaccinations_Sites_Source}
                        </p>
                      </div>
                    </LazyLoad>
                  )}

                {/*Mapbox zoomed into Houston for HC */}

                {newstorySettings.Vaccinations_Sites_Source &&
                  newstorySettings.Market_Key === 'Houston' && (
                    <LazyLoad once offset={200}>
                      <div className="container-l">
                        <MapboxTX
                          mapData={vaccineLocations}
                          center={[-95.500206, 29.7823231]}
                          zoom={8.75}
                          mapStyle="mapbox://styles/devhub/ckcnowjqe19tx1ilpldbyd6zo"
                        />
                        <p className="footnote">
                          {newstorySettings.Vaccinations_Sites_Source}
                        </p>
                      </div>
                    </LazyLoad>
                  )}

                {/*Mapbox zoomed into San Antonio for Express News */}

                {newstorySettings.Vaccinations_Sites_Source &&
                  newstorySettings.Market_Key === 'SanAntonio' && (
                    <LazyLoad once offset={200}>
                      <div className="container-l">
                        <MapboxTX
                          mapData={vaccineLocations}
                          center={[-98.5364176, 29.4912981]}
                          zoom={10}
                          mapStyle="mapbox://styles/devhub/ckcnowjqe19tx1ilpldbyd6zo"
                        />
                        <p className="footnote">
                          {newstorySettings.Vaccinations_Sites_Source}
                        </p>
                      </div>
                    </LazyLoad>
                  )}

                {/* Mapbox zoomed into Midland Texas */}

                {newstorySettings.Vaccinations_Sites_Source &&
                  newstorySettings.Market_Key === 'TK' &&
                  newstorySettings.SEO_Title ===
                    'Midland and Texas COVID-19 Vaccine Tracker' && (
                    <LazyLoad once offset={200}>
                      <div className="container-l">
                        <MapboxTX
                          mapData={vaccineLocations}
                          center={[-102.0835722, 32.0015426]}
                          zoom={9.5}
                          mapStyle="mapbox://styles/devhub/ckcnowjqe19tx1ilpldbyd6zo"
                        />
                        <p className="footnote">
                          {newstorySettings.Vaccinations_Sites_Source}
                        </p>
                      </div>
                    </LazyLoad>
                  )}

                {/* Mapbox zoomed into Beaumont Texas */}

                {newstorySettings.Vaccinations_Sites_Source &&
                  newstorySettings.Market_Key === 'TK' &&
                  newstorySettings.SEO_Title ===
                    'Southeast Texas COVID-19 Vaccine Tracker' && (
                    <LazyLoad once offset={200}>
                      <div className="container-l">
                        <MapboxTX
                          mapData={vaccineLocations}
                          center={[-94.0901005, 30.0809156]}
                          zoom={10.74}
                          mapStyle="mapbox://styles/devhub/ckcnowjqe19tx1ilpldbyd6zo"
                        />
                        <p className="footnote">
                          {newstorySettings.Vaccinations_Sites_Source}
                        </p>
                      </div>
                    </LazyLoad>
                  )}

                {/* Mapbox zoomed into Laredo Texas */}

                {newstorySettings.Vaccinations_Sites_Source &&
                  newstorySettings.Market_Key === 'TK' &&
                  newstorySettings.SEO_Title ===
                    'Laredo and Texas COVID-19 Vaccine Tracker' && (
                    <LazyLoad once offset={200}>
                      <div className="container-l">
                        <MapboxTX
                          mapData={vaccineLocations}
                          center={[-99.5075594, 27.5467022]}
                          zoom={10}
                          mapStyle="mapbox://styles/devhub/ckcnowjqe19tx1ilpldbyd6zo"
                        />
                        <p className="footnote">
                          {newstorySettings.Vaccinations_Sites_Source}
                        </p>
                      </div>
                    </LazyLoad>
                  )}

                {/* Mapbox zoomed into Plainview Texas */}

                {newstorySettings.Vaccinations_Sites_Source &&
                  newstorySettings.Market_Key === 'TK' &&
                  newstorySettings.SEO_Title ===
                    'Plainview  and Texas COVID-19 Vaccine Tracker' && (
                    <LazyLoad once offset={200}>
                      <div className="container-l">
                        <MapboxTX
                          mapData={vaccineLocations}
                          center={[-101.708242, 34.1849927]}
                          zoom={12.65}
                          mapStyle="mapbox://styles/devhub/ckcnowjqe19tx1ilpldbyd6zo"
                        />
                        <p className="footnote">
                          {newstorySettings.Vaccinations_Sites_Source}
                        </p>
                      </div>
                    </LazyLoad>
                  )}
              </section>
            )}

          {newstorySettings.Assignment_Editor &&
            newstorySettings.Assignment_Editor.length > 0 && (
              <AssignmentEditor url={newstorySettings.Assignment_Editor} />
            )}

          {newstorySettings.NewsletterID &&
            newstorySettings.NewsletterLegal &&
            newstorySettings.NewsletterPromo && <Newsletter />}
          <div className="container">
            <Info infoData={useLinks} topper={useTopperText.recircTopper} />

            <h2 className="subhed">About the data</h2>
            {aboutData.map((item) => (
              <p
                key={item.graf}
                dangerouslySetInnerHTML={{ __html: item.graf }}
              ></p>
            ))}
          </div>

          {newstorySettings.secondary_sponsor_img && (
            <SecondarySponsor urls={newstorySettings.secondary_sponsor_img} />
          )}
        </article>
      </main>

      <CreditsSection data={credits} />
    </Layout>
  )
}

export const query = graphql`
  {
    allVaccineData {
      nodes {
        finalJSON
      }
    }
    site {
      siteMetadata {
        EMBEDDED
        MAIN_DOMAIN
        PAYWALL_SETTING
        PROJECT {
          AUTHORS {
            AUTHOR_NAME
            AUTHOR_PAGE
          }
          DATE
          DESCRIPTION
          HEARST_CATEGORY
          IMAGE
          OPT_SLASH
          SLUG
          SOCIAL_TITLE
          SUBFOLDER
          TITLE
          TWITTER_TEXT
          ANALYTICS_CREDIT
          MARKET_KEY
          MAP_GEOGRAPHY
          MARKET_STATE
        }
      }
    }
    allRelatedLinksSheetJson {
      nodes {
        title
        url
      }
    }
    allStorySettingsSheetJson {
      nodes {
        Update_Line
        Analytics_Credit
        Analytics_Section
        Twitter_Text
        Social_Title
        Slug
        SEO_Title
        SEO_Description
        Publish_Date
        Paywall
        Mod_Date
        Market_Key
        Embargo_Date
        Byline
        sponsor_url
        sponsor_img
        sponsor_text
        sponsor_text_kicker
        sponsor_text_url
        secondary_sponsor_img
        coronavirus_url
        Vaccine_Feed
        Explainer_Link
        Vaccinations_Data
        NewsletterID
        NewsletterLegal
        NewsletterPromo
        Display_Title
        Vaccinations_Data_Source
        Vaccinations_Data_Dek
        Phase_Source
        Phase_Dek
        Big_Number_Data
        Vaccinations_Data_Hed
        Page_Dek
        Vaccinations_Sites_Source
        Vaccinations_Sites_Dek
        Vaccinations_Sites_Hed
        Assignment_Editor
      }
    }
    allDataJson {
      nodes {
        trackerText {
          detailDek
          chartTopper
          fdaTopper
          progressSwitcheroo {
            approvedVaccines
          }
          recircTopper
          aboutData {
            graf
          }
        }
      }
    }
    allCreditsSheetJson {
      nodes {
        email
        name
        role
        twitter
      }
    }
  }
`
IndexPage.propTypes = {
  data: PropTypes.object.isRequired,
}

export default IndexPage
